import React, { useEffect, useState } from 'react'

import styled from 'styled-components'

import UserInfoMenu from 'components/UserInfoMenu'

import Brand from 'helpers/brand'

import { color } from 'styles/colors'
import Spinner from 'components/Spinner'
import { usePremiumFeaturesContext } from 'hooks/PremiumFeaturesContext'

type Props = {
  displayMiniVariantSidebar: boolean
}

const Header = ({ displayMiniVariantSidebar }: Props) => {
  const { tier, arePremiumFeaturesLoaded } = usePremiumFeaturesContext()
  const [premium, setPremium] = useState<boolean>(false)

  useEffect(() => {
    if (tier === 'premium' && arePremiumFeaturesLoaded) {
      setPremium(true)
    } else {
      setPremium(false)
    }
  }, [tier, arePremiumFeaturesLoaded])

  if (!arePremiumFeaturesLoaded) {
    return <Spinner variant="page" />
  }

  return (
    <S.Header>
      {!premium &&
        <S.ProductLogo src={displayMiniVariantSidebar ? Brand.faviconPath() : Brand.productLogoPath()} aria-label="product-logo" alt={`${Brand.productName()} logo`} />
      }
      {premium &&
        <S.ProductLogo src={displayMiniVariantSidebar ? Brand.premiumProductMeatballPath() : Brand.premiumProductLogoPath()} aria-label="product-logo" alt={`${Brand.productName()} logo`} />
      }
      <S.UserInfoMenu displayMiniVariantSidebar={displayMiniVariantSidebar} />
    </S.Header>
  )
}

export default Header

const S = {
  ProductLogo: styled.img`
    display: flex;
    height: 33px;
    margin-bottom: 38px;
    justify-content: center;
  `,
  Header: styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    margin: 20px 0px 20px 0px;
  `,
  UserInfoMenu: styled(UserInfoMenu)`
    color: ${color('primaryText')};
    font-size: 16px;
  `
}
